import React, { Component } from "react";
import getEventDetails from "../../services/getEventDetails";
import updateRifiutaEvento from "../../services/updateRifiutaEvento";

class CancelReservation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      descrizione: null,
      locandina: null,
      orario: null,
      titolo: null,
      n_partecipanti: null,
      partecipa: null,
      isLoading: true,
    };
  }

  async componentDidMount() {
    await this.fetchEventDetails();
  }

  fetchEventDetails = async () => {
    const urlParams = new URLSearchParams(window.location.hash.split("?")[1]);
    const token = urlParams.get("token");

    try {
      const eventDetails = await getEventDetails(token);
      const eventData = eventDetails[0];

      console.log(eventData);

      this.setState({
        token,
        data: eventData.data,
        descrizione: eventData.descrizione,
        locandina: eventData.locandina,
        orario: eventData.orario,
        titolo: eventData.titolo,
        n_partecipanti: eventData.n_partecipanti,
        partecipa: eventData.partecipa,
        isLoading: false,
        nome: eventData.studente_nome,
        cognome: eventData.studente_cognome,
      });
    } catch (error) {
      console.error("Errore nel recupero dei dettagli dell'evento:", error);
      this.setState({ isLoading: false });
    }
  };

  handleCancel = async () => {
    const { token } = this.state;
    const isConfirmed = window.confirm(
      "Sei sicuro di voler cancellare la tua prenotazione? L'azione è irreversibile."
    );

    if (isConfirmed) {
      try {
        const response = await updateRifiutaEvento(token);
        console.log("Risposta dal server:", response);

        // Verifica se la risposta ha la struttura corretta
        if (response && response.success) {
          alert(response.message || "Rimosso correttamente dai partecipanti");
          await this.fetchEventDetails();
        } else {
          console.error("Risposta del server non corretta", response);
          alert(response?.error || "Si è verificato un errore.");
        }
      } catch (error) {
        console.error("Errore nell'annullamento dell'iscrizione:", error);
        alert("Si è verificato un errore. Riprova.");
      }
    } else {
      console.log("L'utente ha annullato l'azione.");
    }
  };

  render() {
    const {
      data,
      descrizione,
      locandina,
      orario,
      titolo,
      partecipa,
      isLoading,
      nome,
    } = this.state;

    const styles = {
      container: {
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f4f4f4",
        padding: "20px",
        color: "#333",
        textAlign: "center",
        height: "100vh",
      },
      table: {
        maxWidth: "600px",
        width: "100%",
        backgroundColor: "#ffffff",
        border: "1px solid #ddd",
        borderRadius: "8px",
        margin: "0 auto",
        padding: "20px",
      },
      heading: {
        color: "#e72424",
        fontSize: "24px",
        marginBottom: "10px",
      },
      subHeading: {
        fontSize: "18px",
        color: "#555",
      },
      annulla: {
        fontSize: "12px",
        color: "#aaa",
      },
      buttonContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        marginTop: "20px",
      },
      button: {
        padding: "12px 24px",
        backgroundColor: "#e72424",
        color: "white",
        fontWeight: "bold",
        borderRadius: "4px",
        border: "none",
        cursor: "pointer",
        textDecoration: "none",
        margin: "10px",
      },
      "@media (max-width: 440px)": {
        buttonContainer: {
          flexDirection: "column",
        },
      },
      text: {
        fontSize: "16px",
        lineHeight: "1.6",
        color: "#333",
      },
      statusMessage: {
        fontSize: "18px",
        color: partecipa === -1 ? "#e72424" : "#4CAF50",
        margin: "20px 0",
        fontWeight: "bold",
      },
    };

    if (isLoading) {
      return <div>Loading...</div>;
    }

    let message;
    if (partecipa === -1) {
      message = (
        <p style={styles.statusMessage}>Hai già annullato l'iscrizione.</p>
      );
    }

    return (
      <div style={styles.container}>
        {titolo ? (
          <table style={styles.table}>
            <tr>
              <td>
                <h1 style={styles.heading}>Invito all'evento: {titolo}</h1>
                {message || (
                  <>
                    <p style={styles.subHeading}>
                      Ciao {nome}, hai confermato la partecipazione all'evento{" "}
                      <strong>{titolo}</strong>.
                    </p>
                    <p style={styles.text}>
                      L'evento si terrà il <strong>{data}</strong> alle ore{" "}
                      <strong>{orario}</strong>.
                    </p>

                    {descrizione && (
                      <p
                        style={styles.text}
                        dangerouslySetInnerHTML={{ __html: descrizione }}
                      ></p>
                    )}

                    {locandina && (
                      <div>
                        <img
                          src={locandina}
                          alt="Locandina dell'evento"
                          style={{ width: "50%", marginBottom: "20px" }}
                        />
                      </div>
                    )}

                    {partecipa !== -1 && (
                      <>
                        <p style={styles.annulla}>
                          Se non puoi più partecipare, puoi annullare la tua
                          iscrizione cliccando sul pulsante qui sotto.
                        </p>
                        <div style={styles.buttonContainer}>
                          <button
                            style={styles.button}
                            onClick={this.handleCancel}
                          >
                            Annulla iscrizione
                          </button>
                        </div>
                      </>
                    )}
                  </>
                )}
              </td>
            </tr>
            <img
              src={require("../../images/loghi/nero_trasparente.png")}
              style={{
                position: "relative",
                width: "25%",
                border: "0px solid black",
              }}
            />
          </table>
        ) : (
          <p>Non ci sono dettagli disponibili per l'evento.</p>
        )}
      </div>
    );
  }
}

export default CancelReservation;
